// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"c9e7790c","411":"93d68773","480":"f921fc2e","801":"aecf1c88","866":"67125a52","959":"ecb643ad"}[chunkId] + ".chunk.js";
};